module.exports = __webpack_public_path__ + "img/epr@2x.dd46d94a.webp";